export default "__VITE_ASSET__d07f385c__"